"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

var _IconContainer = require("./IconContainer");

var _IconContainer2 = _interopRequireDefault(_IconContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InsuranceIcon = function InsuranceIcon(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(
    _IconContainer2.default,
    props,
    _react2.default.createElement(
      "svg",
      {
        width: "15px",
        height: "18px",
        viewBox: "0 0 15 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "g",
        {
          id: "190701",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        _react2.default.createElement(
          "g",
          {
            id: "2_NYT-Dashboard-D",
            transform: "translate(-106.000000, -1452.000000)",
            stroke: _buoyTheme2.default.colors[props.color],
            strokeWidth: "1.5"
          },
          _react2.default.createElement(
            "g",
            { id: "Group", transform: "translate(107.000000, 1453.000000)" },
            _react2.default.createElement(
              "g",
              { id: "shield" },
              _react2.default.createElement("path", {
                d: "M6.5,16 C6.5,16 13,12.8 13,8 L13,1.6 L6.5,0 L0,1.6 L0,8 C0,12.8 6.5,16 6.5,16 Z",
                id: "Shape"
              })
            ),
            _react2.default.createElement(
              "g",
              { id: "check-copy-11", transform: "translate(3.250000, 5.333333)" },
              _react2.default.createElement("polyline", {
                id: "Shape",
                points: "6.03571412 -4.6629367e-15 1.88616066 4.08571417 -3.99680289e-15 2.22857137"
              })
            )
          )
        )
      )
    )
  );
};

InsuranceIcon.defaultProps = {
  color: "neutralDark"
};

exports.default = InsuranceIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/InsuranceIcon.js
// module id = 422
// module chunks = 168707334958949